<template>
  <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-8">
    <h2 class="col-span-6 laptop:col-span-5">{{ data?.companyPage?.data?.attributes?.environmentsocial_title }}</h2>
    <img src="/images/company/people-environment.jpg" class="col-span-6 mt-8 w-full laptop:col-span-8 laptop:mt-10" />
    <p class="col-span-6 mt-8 italic laptop:col-span-5 laptop:col-start-4 laptop:mt-10">
      {{ data?.companyPage?.data?.attributes?.environmentsocial_quote }}
    </p>

    <h2 class="col-span-6 col-start-1 mt-8 text-right capitalize laptop:col-span-3 laptop:col-start-6 laptop:mt-14">
      {{ data?.companyPage?.data?.attributes?.environmentsocial_social_title }}
    </h2>
    <p class="col-span-6 mt-8 laptop:col-span-5 laptop:col-start-4 laptop:mt-4">
      {{ data?.companyPage?.data?.attributes?.environmentsocial_paragraph }}
    </p>
  </div>
</template>
<script setup>
import { Companypage2DataKey } from "~/symbols/symbols";
const data = inject(Companypage2DataKey);
</script>
<style lang="scss" scoped></style>
